import * as React from "react";
import { AnchorOutlineButton } from "../../components/OutlineButton";
import "./HomeCTA.scss";

interface IHomeCTAProps {}

export const HomeCTA: React.FunctionComponent<IHomeCTAProps> = (props) => {
  return (
    <div className="home-cta">
      <div className="home-cta__teaser desktop">
        <h2>Save the Date</h2>
      </div>
      <div className="home-cta__content">
        <div className="home-cta__content-inner">
          <div className="home-cta__teaser mobile">
            <h2>Save the Date</h2>
          </div>
          <h3>John Deere CES Press Conference</h3>
          <div className="green">Nothing Runs Like a Deere™.</div>
          <div className="green big">Autonomously.</div>
          <h3>January 4, 2022 | 2:00–2:45 PM CST | Mandalay Bay + Livestream</h3>
          <AnchorOutlineButton className="yellow solid" text={"Add to Calendar"} to={"https://jd-ces-2022.s3.amazonaws.com/john-deere-ces-2022.ics"} />
        </div>
      </div>
    </div>
  );
};
